import React, {useState, useContext, useEffect} from 'react';
import Spinner from '../../Spinner';
import {useTranslation} from 'react-i18next';
import Datepicker from 'react-tailwindcss-datepicker';
import SelectComponentNotSorted from '../../Selects/SelectComponentNotSorted';
import SelectComponent from '../../Selects/SelectComponent';
import {ToastContainer} from 'react-toastify';
import {useHistory, useParams} from 'react-router-dom';
import {Context} from '../../../Helpers/Auth';
import {toast} from 'react-toastify';

import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import Status from '../../../components/Negocios/NovoNegocio/Status';
import InfoAdicional from './InfoAdicional';
import DadosBase from '../../../components/Negocios/NovoNegocio/DadosBase';
import moment from 'moment';

import {
    getDados,
    getSubtipos,
    getEstabelecimentos,
    postNegocio,
    getNegociosId,
    getContactosProspect,
    getRepresentantes,
    getOrigens,
    getMarcasConcorrencia,
    getDuracaoCF,
    getCarenciaCF,
    getNumRendaCF,
    getPortesMesCF,
    getSeguroRespCivilCF,
    getTaxaNominalCF,
    getEntradaInicialCF,
    getRendaMensalCF,
    getValorResidualCF,
    getSeguroCascoMesCF,
    getDespesaContratoCF,
    getMarcas,
} from '../../../pages/requests';
import Concorrentes from '../Concorrentes';
import Artigos from '../Artigos';
import {getMotivosPerdaNegocio, getStatusNegocio} from '../api';
import ContratoManutencao from '../ContratoManutencao';
import ContratoFinanceiro from '../ContratoFinanceiro';
import ExitForm from '../../ExitFormModal';
import LoadingModal from '../../LoadingModal';

function NovoNegocio({
    novoAgendamento,
    setNovoAgendamento,
    negocio,
    setGuardar,
    guardar,
    showForm,
    setOnChangeForm,
    editarNegocio,
    openTab,
    setNovaProposta,
    novaProposta,
    setEditarNegocio,
    setContratoManutencao,
    contratoManutencao,
    setContratoFinanceiro,
    contratoFinanceiro,
    onChangeForm,
    setOpenTab,
    setShowForm,
}) {
    const FORMATO_DATA = 'YYYY-MM-DD';

    const {oficina, userRepresentante, verifAuthenticated} = useContext(Context);
    const [loading, setLoading] = useState(false);
    const {t} = useTranslation();

    const [etapaR, setEtapaR] = useState(null);
    const [denominacao, setDenominacao] = useState('');
    const [valor, setValor] = useState(0);
    // const [obsEquipamento, setObsEquipamento] = useState("");
    const [respRV, setRespRV] = useState(userRepresentante);
    const [probabilidadeNegocioR, setProbabilidadeNegocioR] = useState(null);
    const [contaR, setContaR] = useState(null);
    const [industriaR, setIndustriaR] = useState(null);
    const [estabR, setEstabR] = useState(oficina);
    const [divisaR, setDivisaR] = useState(null);
    const [contas, setContas] = useState([]);
    const [responsaveisTodos, setResponsaveisTodos] = useState([]);
    const [subtipos, setSubtipos] = useState([]);
    const [estabelecimentos, setEstabelecimentos] = useState([]);
    const [probabilidadeFiltros, setProbabilidadeFiltros] = useState([]);
    const [moedas, setMoedas] = useState([]);
    const [negocioData, setNegocioData] = useState(null);
    const [etapas, setEtapas] = useState([]);
    const [optionsMarca, setOptionsMarca] = useState([]);
    const [categoriasArtigos, setCategoriasArtigos] = useState([]);
    const [optionsVersao, setOptionsVersao] = useState([]);
    const [respErro, setRespErro] = useState("");

    //estado negocio
    const [estados, setEstados] = useState([]);
    const [motivos, setMotivos] = useState([]);
    const [estado, setEstado] = useState(null);
    const [validacaoEstado, setValidacaoEstado] = useState(false);

    const [subtipoR, setSubtipoR] = useState(subtipos[0]);

    const [startDate, setStartDate] = useState({
        startDate: null,
        endDate: null,
    });

    const [etpI, setETPI] = useState('');
    const [motivoR, setMotivoR] = useState(null);
    const [consulta, setConsulta] = useState(false);
    const [urgente, setUrgente] = useState(false);
    const [hotDeal, setHotDeal] = useState(false);

    const [contactos, setContactos] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [marcas, setMarcas] = useState([]);
    const [marcasConcorrencias, setMarcasConcorrencias] = useState([]);
    const [nacionaisInternacionais, setNacionaisInternacionais] = useState([]);

    const [tipos, setTipos] = useState([]);
    const [modelos, setModelos] = useState([]);
    const [origens, setOrigens] = useState([]);
    const [contactoR, setContactoR] = useState([]);
    const [historicoStatus, setHistoricoStatus] = useState([]);
    const [categoria, setCategoria] = useState('');

    const [origem, setOrigem] = useState('');
    const [observacoes, setObservacoes] = useState('');
    const [neg, setNeg] = useState('');
    const history = useHistory();

    console.log(negocioData, 'negocio');

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }
    const [linhasArtigos, setLinhasArtigos] = useState([
        {
            idLinha: Math.random() * 999999 + Number.EPSILON,
            referencia: '',
            preco: 0,
            categoria: null,
            marca: null,
            tipo: null,
            modelo: null,
            versao: null,
            observacoes: '',
        },
    ]);

    const [concorrentes, setConcorrentes] = useState([]);

    const [linhasConcorrentes, setLinhasConcorrentes] = useState([
        {
            id: '',
            idLinha: Math.random() * 999999 + Number.EPSILON,
            descricao: '',
            valor: 0,
            marca: null,
            modelo: '',
            pontosFortes: '',
            pontosFracos: '',
        },
    ]);

    // Contrato de Manutenção
    const [arrayTipoContrato, setArrayTipoContrato] = useState([]);
    const [tipoContrato, setTipoContrato] = useState(null);
    const [arrayLubrificantes, setArrayLubrificantes] = useState([]);
    const [lubrificantes, setLubrificantes] = useState(null);
    const [arrayDuracaoContrato, setArrayDuracaoContrato] = useState([]);
    const [duracaoContrato, setDuracaoContrato] = useState(null);
    const [arrayHorasAno, setArrayHorasAno] = useState([]);
    const [horasAno, setHorasAno] = useState(null);
    const [localTrabalho, setLocalTrabalho] = useState('');

    // Contrato financeiro

    const [condicoesPagamento, setCondicoesPagamento] = useState('');
    const [duracao, setDuracao] = useState('');
    const [carencia, setCarencia] = useState('');
    const [numRendas, setNumRendas] = useState('');
    const [portesMes, setPortesMes] = useState('');
    const [seguroCivil, setSeguroCivil] = useState('');
    const [taxaNominal, setTaxaNominal] = useState('');
    const [entradaInicial, setEntradaInicial] = useState('');
    const [rendaMensal, setRendaMensal] = useState('');
    const [valorResidual, setValorResidual] = useState('');
    const [seguroCasco, setSeguroCasco] = useState('');
    const [despesasContrato, setDespesasContrato] = useState('');

    //Arrays contrato financeiro

    const [arrayCondicoesPagamento, setArrayCondicoesPagamento] = useState([]);
    const [arrayDuracao, setArrayDuracao] = useState([]);
    const [arrayCarencia, setArrayCarencia] = useState([]);
    const [arrayNumRendas, setArrayNumRendas] = useState([]);
    const [arrayPortesMes, setArrayPortesMes] = useState([]);
    const [arraySeguroCivil, setArraySeguroCivil] = useState([]);
    const [arrayTaxaNominal, setArrayTaxaNominal] = useState([]);
    const [arrayEntradaInicial, setArrayEntradaInicial] = useState([]);
    const [arrayRendaMensal, setArrayRendaMensal] = useState([]);
    const [arrayValorResidual, setArrayValorResidual] = useState([]);
    const [arraySeguroCasco, setArraySeguroCasco] = useState([]);
    const [arrayDespesasContrato, setArrayDespesasContrato] = useState([]);

    // VALIDAÇÕES
    const [validacaoConta, setValidacaoConta] = useState(false);
    const [validacaoResp, setValidacaoResp] = useState(false);
    const [validacaoProbNeg, setValidacaoProbNeg] = useState(false);
    const [validacaoEtapa, setValidacaoEtapa] = useState(false);
    const [validacaoValor, setValidacaoValor] = useState(false);
    const [ValidacaoEstab, setValidacaoEstab] = useState(false);
    const [ValidacaoDivisa, setValidacaoDivisa] = useState(false);
    const [validacaoMotivo, setValidacaoMotivo] = useState(false);
    const [validacaoContacto, setValidacaoContacto] = useState(false);
    const [validacaoStartDate, setValidacaoStartDate] = useState(false);
    const [validacaoDenominacao, setValidacaoDenominacao] = useState(false);

    const [validacaoOrigem, setValidacaoOrigem] = useState(false);
    const [validacaoObservacoes, setValidacaoObservacoes] = useState(false);
    const [loadingM, setLoadingM] = useState(false);
    const [showExitModal, setShowExitModal] = useState(false);
    console.log(despesasContrato, 'despesa');
    const handleLeavePage = event => {
        debugger;
        if (onChangeForm) {
            setShowExitModal(true);
            if (event?.preventDefault) {
                event?.preventDefault();
            }
            return false;
        }
        return true;
    };

    useEffect(() => {
        if (history.location.state?.prospect) {
            var _prospect = history.location.state?.prospect;
            console.log(_prospect, 'prosp');
            setContaR({value: _prospect.codigoCliente, label: _prospect.nomeCliente});
            setRespRV({value: _prospect.responsavel.value, label: _prospect.responsavel.label});
            if (contactos.length == 1) {
                setContactoR(contactos[0]);
            }

            // setEstabelecimentoVenda(_prospect.estabelecimento);
            // setEstabelecimentoExpedicao(_prospect.estabelecimento);

            // setProspectEscolhido({value: _prospect.codEmpresa, label: _prospect.empresa});
            // debugger;
            // getProspectClientes(_prospect.codEmpresa).then(res => {
            //     debugger;
            //     setLingua(res.data.clientes[0].lingua);
            // });

            // setTipoContrato({value: _prospect.tipoContrato.value, label: _prospect.tipoContrato.label});
            // setLubrificantes({value: _prospect.lubrificantes.value, label: _prospect.lubrificantes.label});
            // setDuracaoContrato({value: _prospect.duracaoContrato.value, label: _prospect.duracaoContrato.label});
            // setHorasAno({value: _prospect.horasAno.value, label: _prospect.horasAno.label});
            // setLocalTrabalho(_prospect.localTrabalho);

            // setContactoR(_prospect.contactos);
            // setMoeda({value: _prospect.divisa.value, label: _prospect.divisa.label});
            // setRepresentante(_prospect.responsavel);

            // setNegocio({..._prospect, value: _prospect.num, label: _prospect.nome});

            // // setArea(_prospect.industria);

            // setLinhas(
            //     _prospect.artigos.map(a => {
            //         return {
            //             ...a,
            //             preco: a.preco,
            //             quantidade: 1,
            //             desconto: 0,
            //             acessoriosExtra: [],
            //             atributos: [],
            //             acessos: [],
            //         };
            //     }),
            // );
        }
    }, [history]);

    useEffect(() => {
        const unblock = history.block(handleLeavePage);

        window.addEventListener('beforeunload', handleLeavePage);

        return () => {
            unblock();
            window.removeEventListener('beforeunload', handleLeavePage);
        };
    }, [onChangeForm]);

    function pushProposta() {
        history.push(`Propostas`, {negocio: negocioData});
    }
    useEffect(() => {
        if (novaProposta && negocioData && negocioData?.tipoCliente != 4) {
            pushProposta();
            setNovaProposta(false);
        }
        if (novaProposta && negocioData?.tipoCliente == 4) {
            toast.warn(t('Tem de criar Cliente primeiro!'), {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
        }
    }, [novaProposta, negocioData]);

    function pushAgendamento() {
        history.push(`Agendamentos`, {negocio: negocioData});
    }
    useEffect(() => {
        if (novoAgendamento && negocioData) {
            pushAgendamento();
            setNovoAgendamento(false);
        }
    }, [novoAgendamento, negocioData]);

    useEffect(() => {
        setDenominacao(
            linhasArtigos
                .filter(l => l.marca && l.modelo)
                .map(l => l.marca.label + ' - ' + l.modelo.label)
                .join(', '),
        );
        setValidacaoDenominacao(false);
    }, [linhasArtigos]);

    useEffect(() => {
        if (contaR) {
            getContactosProspect(contaR.value, lang).then(function (response) {
                var comps = [];
                response.data.contactos?.forEach(element => {
                    const contacto = {
                        value: element.id,
                        label: element.nome + '' + element.apelido + ' - ' + element.telemovel,
                    };
                    comps.push(contacto);
                });
                setContactos(comps);
            });
        }
    }, [contaR]);

    useEffect(() => {
        if (negocio) {
            setEditarNegocio(false);
            const idRecebido = negocio.num;
            setLoading(true);
            getNegociosId(idRecebido, lang)
                .then(res => {
                    setNegocioData(res.data);
                    setCondicoesPagamento(res.data.condicoesPagamento);
                    // NOVOS CAMPOS -----
                    setDuracao(res.data.duracao);
                    setCarencia(res.data.carencia);
                    setNumRendas(res.data.numRendas);
                    setPortesMes(res.data.portesMes);
                    setSeguroCivil(res.data.seguroCivil);
                    setTaxaNominal(res.data.taxaNominal);
                    setEntradaInicial(res.data.entradaInicial);
                    setRendaMensal(res.data.rendaMensal);
                    setValorResidual(res.data.valorResidual);
                    setSeguroCasco(res.data.seguroCasco);
                    setDespesasContrato(res.data.despesasContrato);

                    // --------

                    setOrigem(res.data.origem);
                    setCategoria(res.data.categoria);

                    setDenominacao(res.data.nome);
                    setObservacoes(res.data.observacoes);

                    setHistoricoStatus(res.data.etapas);
                    if (res.data.artigos.length > 0) {
                        setLinhasArtigos(
                            res.data.artigos.map(a => {
                                return {...a, idLinha: Math.random() * 999999 + Number.EPSILON};
                            }),
                        );
                    }
                    setContactoR(res.data.contactos);
                    setEstado(res.data.status);

                    if (res.data.concorrentes.length > 0) {
                        setLinhasConcorrentes(res.data.concorrentes);
                    }

                    // setObsEquipamento(res.data.obsEquipamento)

                    setMotivoR(res.data.motivoPerda);

                    setStartDate({
                        startDate: moment(res.data.dataFecho).format(FORMATO_DATA),
                        endDate: moment(res.data.dataFecho).format(FORMATO_DATA),
                    });

                    etapas.forEach(element => {
                        if (element.value == res.data.etapa) {
                            setEstabR(element);
                            setETPI(element.label);
                        }
                    });

                    setContaR({
                        value: res.data.codEmpresa,
                        label: res.data.empresa,
                    });
                    setValor(res.data.valor);

                    setRespRV(res.data.responsavel);
                    setSubtipoR({
                        value: res.data.subtipo,
                        label: res.data.subtipo,
                    });

                    setProbabilidadeNegocioR(res.data.probabilidade);

                    // setConsulta
                    setUrgente(res.data.urgente);
                    setHotDeal(res.data.hotDeal);
                    setIndustriaR(res.data.industria);
                    setEtapaR({
                        value: res.data.etapa,
                        label: res.data.descricaoEtapa,
                    });

                    setEstabR(res.data.estabelecimento);
                    setDivisaR(res.data.divisa);

                    setContratoManutencao(res.data.contratoManutencao);
                    setContratoFinanceiro(res.data.contratoFinanceiro);

                    setTipoContrato(res.data.tipoContrato);
                    setLubrificantes(res.data.lubrificantes);
                    setDuracaoContrato(res.data.duracaoContrato);
                    setHorasAno(res.data.horasAno);
                    setLocalTrabalho(res.data.localTrabalho);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [negocio]);

    useEffect(() => {
        getDados(lang).then(res => {
            setCategorias(res.data.categorias);

            var comps1 = [];
            res.data.concorrentes.forEach(element => {
                const conc = {
                    value: element.id,
                    label: element.descricao,
                };
                comps1.push(conc);
            });
            setConcorrentes(comps1);

            var comps3 = [];
            res.data.probabilidadeNegocio.forEach(element => {
                const pN = {
                    value: element.id,
                    label: element.descricao,
                };
                comps3.push(pN);
            });
            setProbabilidadeFiltros(comps3);

            // var comps4 = [];
            // res.data.modelos.forEach(element => {
            //     const mod = {
            //         value: element.value,
            //         label: element.label,
            // dep:element.dep
            //     };
            //     comps4.push(mod);
            // });
            // setModelos(comps4);

            setEtapas(res.data.etapas);
        });

        getOrigens(lang).then(res => {
            setOrigens(res.data.origens);
        });

        getRepresentantes(lang).then(res => {
            setResponsaveisTodos(res.data.representantes);
        });

        getMarcas(lang).then(res => {
            setMarcas(res.data.marcas);
        });
        getMarcasConcorrencia(lang).then(res => {
            setMarcasConcorrencias(res.data.marcas);
        });

        // getSubtipos().then(function (response) {
        //     var comps = [];

        //     comps.push({
        //         value: ' ',
        //         label: t('selecioneOpcao'),
        //     });

        //     response.data.subtipos.forEach(element => {
        //         const subtipo = {
        //             value: element.idItem,
        //             label: element.idItem,
        //         };
        //         comps.push(subtipo);
        //     });
        //     setSubtipos(comps);
        // });

        getEstabelecimentos(lang).then(function (response) {
            setEstabelecimentos(response.data.estabelecimentos);
        });

        //--------------------
    }, []);

    async function GuardarNegocio() {
        var podeGravar = true;
        setLoadingM(true)
        // Dados Base
        if (!respRV) {
            setValidacaoResp(true);
            podeGravar = false;
        }
        if (!contaR) {
            setValidacaoConta(true);
            podeGravar = false;
        }
        if (!estabR) {
            setValidacaoEstab(true);
            podeGravar = false;
        }
        if (!denominacao) {
            setValidacaoDenominacao(true);
            podeGravar = false;
        }
        if (contactoR.length === 0) {
            setValidacaoContacto(true);
            podeGravar = false;
        }
        if (!startDate.startDate) {
            setValidacaoStartDate(true);
            podeGravar = false;
        }
        if (!probabilidadeNegocioR) {
            setValidacaoProbNeg(true);
            podeGravar = false;
        }
        if (!origem) {
            setValidacaoOrigem(true);
            podeGravar = false;
        }

        // Status
        if (!estado || estado.value == '') {
            setValidacaoEstado(true);
            podeGravar = false;
        }
        if (!etapaR) {
            setValidacaoEtapa(true);
            podeGravar = false;
        }

        if (estado?.value == '00003' && !motivoR) {
            setValidacaoMotivo(true);
            podeGravar = false;
        }

        // Equipamentos
        if (!divisaR) {
            setValidacaoDivisa(true);
            podeGravar = false;
        }
        if (!valor) {
            setValidacaoValor(true);
            podeGravar = false;
        }
        if (linhasArtigos[0].categoria == null) {
            linhasArtigos.forEach(linha => {
                if (!linha.categoria) {
                    linha.validacaoCategoria = true;
                    podeGravar = false;
                }
                if (!linha.marca) {
                    linha.validacaoMarca = true;
                    podeGravar = false;
                }
                if (!linha.nacionalInternacional) {
                    linha.validacaoNacionalInternacional = true;
                    podeGravar = false;
                }
                if (!linha.tipo) {
                    linha.validacaoTipo = true;
                    podeGravar = false;
                }
                if (!linha.modelo) {
                    linha.validacaoModelo = true;
                    podeGravar = false;
                }
                if (!linha.versao) {
                    linha.validacaoVersao = true;
                    podeGravar = false;
                }
                if (!linha.referencia) {
                    linha.validacaoArtigos = true;
                    podeGravar = false;
                }
            });
        } else {
            const novasLinhas = linhasArtigos.filter(linhaArtigo => linhaArtigo.categoria !== null && linhaArtigo.marca !== null);
            setLinhasArtigos(novasLinhas);
        }

        if (!podeGravar) {
            setLoadingM(false)
            toast.warn(t('preenchaCampos'), {
                position: 'top-right',
                autoClose: 6000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'light',
            });
            return;
        }

        const guardarConclusaoWS = new Promise((resolve, reject) => {
            postNegocio(
                negocio?.num ?? '',
                denominacao,
                respRV,
                valor,
                startDate.startDate,
                etapaR.value,
                motivoR,
                contaR.value,
                industriaR,
                probabilidadeNegocioR,
                estabR,
                divisaR,
                linhasConcorrentes.filter(x => x.descricao !== ''),
                linhasArtigos.filter(l => l.referencia),
                origem,
                observacoes,
                estado,
                contactoR,
                contratoManutencao,
                contratoFinanceiro,
                tipoContrato,
                lubrificantes,
                duracaoContrato,
                horasAno,
                localTrabalho,
                urgente,
                hotDeal,
                condicoesPagamento,
                duracao,
                carencia,
                numRendas,
                portesMes,
                seguroCivil,
                taxaNominal,
                entradaInicial,
                rendaMensal,
                valorResidual,
                seguroCasco,
                despesasContrato,
                lang,
            )
                .then(res => {
                    let dados = res.data;
debugger
                    if (dados.success) {
                        resolve(dados.message || 'Sucesso!');
                    } else {
                        let mensagem = dados.errorMessages;
                        let resposta = mensagem && mensagem.length > 0 ? mensagem.join(', ') : t('toastErro');
                        setRespErro(resposta)
                        reject(resposta);
                       
                    }
                })
                .catch(error => {
                    reject(t('toastErroServidor'));
                });
        });

        toast.promise(
            guardarConclusaoWS,
            {
                success: {
                    
                    render() {
                        setLoadingM(false)
                        setShowForm(false);
                        setOnChangeForm(false);
                        setOpenTab(1);

                        return t('negocioCriado');
                    },
                },
                // pending: t('a_guardar'),
                error: {
                    render(data) {
                        debugger
                        setLoadingM(false)
                        // return data;
                        return typeof data === 'string' ? data : respErro[0];
                    },
                },
            },
            {autoClose: 2000},
        );
        // para poder alterar states de qualquer coisa tenho que ter a promise concluida, senão o toast nunca desaparece
        // por isso tenho de fazer um await
        await Promise.allSettled([guardarConclusaoWS]);
    }
    useEffect(async () => {
        if (guardar) {
            await GuardarNegocio();
            setGuardar(false);
        }
    }, [guardar]);

    return (
        <>
            {loading && (
                <div className="flex flex-row mt-14 justify-center">
                    <>
                        <Spinner />
                    </>
                </div>
            )}
            {loadingM && <LoadingModal />}
            {!loading && (
                <form className="mt-4">
                    {showForm && openTab === 3 && (
                        <DadosBase
                            info={{
                                editarNegocio,
                                negocio,
                                loading,
                                responsaveisTodos,
                                setRespRV,
                                respRV,
                                setValidacaoResp,
                                validacaoResp,

                                setContas,
                                contas,
                                setContaR,
                                contaR,
                                setValidacaoConta,
                                validacaoConta,

                                setDivisaR,
                                setValidacaoDivisa,

                                estabelecimentos,
                                setEstabR,
                                estabR,
                                setValidacaoEstab,
                                ValidacaoEstab,

                                setDenominacao,
                                denominacao,
                                setValidacaoDenominacao,
                                validacaoDenominacao,

                                setContactos,
                                contactos,
                                setContactoR,
                                contactoR,
                                setValidacaoContacto,
                                validacaoContacto,

                                setStartDate,
                                startDate,
                                setValidacaoStartDate,
                                validacaoStartDate,

                                probabilidadeFiltros,
                                setProbabilidadeNegocioR,
                                probabilidadeNegocioR,
                                setValidacaoProbNeg,
                                validacaoProbNeg,

                                origens,
                                setOrigem,
                                origem,
                                setValidacaoOrigem,
                                validacaoOrigem,

                                observacoes,
                                setObservacoes,
                                setValidacaoObservacoes,

                                setContratoManutencao,
                                contratoManutencao,

                                setContratoFinanceiro,
                                contratoFinanceiro,
                            }}
                            setOnChangeForm={setOnChangeForm}
                        />
                    )}

                    {showForm && openTab === 7 && (
                        <Status
                            info={{
                                loading,
                                editarNegocio,
                                setOnChangeForm,

                                setConsulta,
                                consulta,
                                setUrgente,
                                setHotDeal,
                                hotDeal,
                                urgente,
                                etapas,
                                setEtapaR,
                                etapaR,
                                setValidacaoEtapa,
                                validacaoEtapa,

                                setMotivoR,
                                motivoR,
                                setValidacaoMotivo,
                                validacaoMotivo,
                                setEstados,
                                estados,
                                setEstado,
                                estado,
                                setValidacaoEstado,
                                validacaoEstado,

                                negocio,
                                negocioData,
                                historicoStatus,
                                motivos,
                                setMotivos,
                            }}
                        />
                    )}

                    {showForm && openTab === 6 && (
                        <Concorrentes
                            editarNegocio={editarNegocio}
                            concorrentes={concorrentes}
                            setLinhasConcorrentes={setLinhasConcorrentes}
                            linhasConcorrentes={linhasConcorrentes}
                            marcas={marcasConcorrencias}
                        />
                    )}
                    {/* Tab de equipamentos */}
                    {showForm && openTab === 10 && (
                        <Artigos
                            info={{
                                categoriasArtigos,
                                editarNegocio,
                                setOnChangeForm,

                                moedas,
                                setDivisaR,
                                divisaR,
                                setValidacaoDivisa,
                                ValidacaoDivisa,

                                setValor,
                                valor,
                                setValidacaoValor,
                                validacaoValor,

                                marcas,
                                nacionaisInternacionais,
                                tipos,
                                modelos,
                                setOptionsVersao,
                                optionsVersao,

                                setMoedas,
                                setCategoriasArtigos,
                                setMarcas,
                                setNacionaisInternacionais,
                                setTipos,
                                setModelos,
                                setOptionsVersao,
                            }}
                            linhasArtigos={linhasArtigos}
                            setLinhasArtigos={setLinhasArtigos}
                        />
                    )}

                    {/* separador de Contrato de manutenção */}
                    {showForm && openTab === 11 && (
                        <ContratoManutencao
                            editarNegocio={editarNegocio}
                            tipoContrato={tipoContrato}
                            setTipoContrato={setTipoContrato}
                            arrayTipoContrato={arrayTipoContrato}
                            lubrificantes={lubrificantes}
                            setLubrificantes={setLubrificantes}
                            arrayLubrificantes={arrayLubrificantes}
                            duracaoContrato={duracaoContrato}
                            setDuracaoContrato={setDuracaoContrato}
                            arrayDuracaoContrato={arrayDuracaoContrato}
                            arrayHorasAno={arrayHorasAno}
                            horasAno={horasAno}
                            setHorasAno={setHorasAno}
                            localTrabalho={localTrabalho}
                            setLocalTrabalho={setLocalTrabalho}
                            setOnChangeForm={setOnChangeForm}
                            setArrayTipoContrato={setArrayTipoContrato}
                            setArrayLubrificantes={setArrayLubrificantes}
                            setArrayDuracaoContrato={setArrayDuracaoContrato}
                            setArrayHorasAno={setArrayHorasAno}
                        />
                    )}

                    {/* Separador de Contrato Financeiro */}
                    {showForm && openTab === 12 && (
                        <ContratoFinanceiro
                            condicoesPagamento={condicoesPagamento}
                            setCondicoesPagamento={setCondicoesPagamento}
                            editarNegocio={editarNegocio}
                            setOnChangeForm={setOnChangeForm}
                            // novos campos
                            duracao={duracao}
                            setDuracao={setDuracao}
                            carencia={carencia}
                            setCarencia={setCarencia}
                            numRendas={numRendas}
                            setNumRendas={setNumRendas}
                            portesMes={portesMes}
                            setPortesMes={setPortesMes}
                            seguroCivil={seguroCivil}
                            setSeguroCivil={setSeguroCivil}
                            taxaNominal={taxaNominal}
                            setTaxaNominal={setTaxaNominal}
                            entradaInicial={entradaInicial}
                            setEntradaInicial={setEntradaInicial}
                            rendaMensal={rendaMensal}
                            setRendaMensal={setRendaMensal}
                            valorResidual={valorResidual}
                            setValorResidual={setValorResidual}
                            seguroCasco={seguroCasco}
                            setSeguroCasco={setSeguroCasco}
                            despesasContrato={despesasContrato}
                            setDespesasContrato={setDespesasContrato}
                            //Arrays
                            arrayCondicoesPagamento={arrayCondicoesPagamento}
                            arrayDuracao={arrayDuracao}
                            arrayCarencia={arrayCarencia}
                            arrayNumRendas={arrayNumRendas}
                            arrayPortesMes={arrayPortesMes}
                            arraySeguroCivil={arraySeguroCivil}
                            arrayTaxaNominal={arrayTaxaNominal}
                            arrayEntradaInicial={arrayEntradaInicial}
                            arrayRendaMensal={arrayRendaMensal}
                            arrayValorResidual={arrayValorResidual}
                            arraySeguroCasco={arraySeguroCasco}
                            arrayDespesasContrato={arrayDespesasContrato}
                            setArrayDuracao={setArrayDuracao}
                            setArrayCarencia={setArrayCarencia}
                            setArrayNumRendas={setArrayNumRendas}
                            setArrayPortesMes={setArrayPortesMes}
                            setArraySeguroCivil={setArraySeguroCivil}
                            setArrayTaxaNominal={setArrayTaxaNominal}
                            setArrayEntradaInicial={setArrayEntradaInicial}
                            setArrayRendaMensal={setArrayRendaMensal}
                            setArrayValorResidual={setArrayValorResidual}
                            setArraySeguroCasco={setArraySeguroCasco}
                            setArrayDespesasContrato={setArrayDespesasContrato}
                        />
                    )}
                </form>
            )}
            <ToastContainer />
            {showExitModal && (
                <ExitForm
                    cancelar={() => setShowExitModal(false)}
                    back={() => {
                        setShowForm(false);
                        setShowExitModal(false);
                        setEditarNegocio(false);
                    }}
                />
            )}
        </>
    );
}

export default NovoNegocio;
